import {useEffect, useRef} from 'react';
import {useModalContext} from '../modalContext';
import {NavigationTopbarContainer} from '../shared-components/grid-features/NavigationTopbar';

export const useMainContentHeight = () => {
    const targetRef = useRef(null);
    const {isInModal, modalRef} = useModalContext();
    // we use this function to resize the sidebar height and position it properly
    // depending on if it is in a popup modal or not.
    useEffect(() => {
        // apply any resizing that may be needed to position the sidebar correctly
        const targetElement = targetRef.current;
        if (!isInModal) {
            // lookup the NavigationTopbarContainer className
            const topNav = String(NavigationTopbarContainer);
            const sourceNavTopBarElement = document.querySelector(topNav);
            if (sourceNavTopBarElement && targetElement) {
                const sourceHeight = sourceNavTopBarElement.offsetHeight;
                targetElement.style.top = `${sourceHeight}px`;
                targetElement.style.height = `calc(100vh - ${sourceHeight}px )`;
            }
        }
    }, [isInModal, modalRef]);
    return {targetRef};
};
